export default __webpack_public_path__ + "static/media/exponentFraction.8eb6ef93.svg";